// extracted by mini-css-extract-plugin
module.exports = {"appIcon":"style_appIcon__QQ17L"};